// extracted by mini-css-extract-plugin
module.exports = {"icon":"ImageUploader_icon__3Sech","buttonContainer":"ImageUploader_buttonContainer__2CAa9"};